;$(function() {

	$('.tabs__tab').click(function() {
		if ($(this).hasClass('active'))
			return;

		let papa = $(this).parents('.tabs').eq(0);
		let tab = $(this).attr('data-tab');

		papa.find('.tabs__tab.active').removeClass('active');
		$(this).addClass('active');

		papa.find('.tabs__block.active').removeClass('active');
		papa.find('.tabs__block[data-tab="' + tab + '"]').addClass('active');
	});

});